import * as Types from '../../../../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Fri Jul 25 2025 19:42:13 GMT+0000 (Coordinated Universal Time)
*/

const defaultOptions = {} as const;
export type GetUnregisteredFormQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetUnregisteredFormQuery = { __typename?: 'Query', form: { __typename?: 'Form', id: string, formFields: Array<{ __typename?: 'FormField', id: string, slug?: string | null | undefined, enabled: boolean, required: boolean, custom?: boolean | null | undefined, inputType?: string | null | undefined, label?: string | null | undefined, placeholder?: string | null | undefined, options?: Array<{ __typename?: 'CustomFieldOption', label: string, value: string }> | null | undefined, integrationSettings?: { __typename?: 'IntegrationSettings', integrationId: number, fieldMappings: { __typename?: 'IntegrationSettingsFieldMappings', id: string, isCustom: boolean } } | null | undefined, validation?: { __typename?: 'Validations', isLength?: { __typename?: 'LengthValidation', minLength?: number | null | undefined, maxLength?: number | null | undefined } | null | undefined } | null | undefined }>, customizations: { __typename?: 'FormCustomizations', brandedValues?: { __typename?: 'FormBrandedCustomizations', borderRadius?: number | null | undefined, buttonBorderRadius?: number | null | undefined, buttonColor?: string | null | undefined, buttonFont?: string | null | undefined, buttonFontUrl?: string | null | undefined, dateTimeBackgroundColor?: string | null | undefined, dateTimeTextColor?: string | null | undefined, formBackgroundColor?: string | null | undefined, containerBorderRadius?: number | null | undefined, hasPoweredByWistiaBadge?: boolean | null | undefined, headingTextColor?: string | null | undefined, inputBorderColor?: string | null | undefined, inputBorderRadius?: number | null | undefined, inputFont?: string | null | undefined, inputFontUrl?: string | null | undefined, inputLabelFont?: string | null | undefined, inputLabelFontUrl?: string | null | undefined, inputTextColor?: string | null | undefined, mainTextColor?: string | null | undefined, pageBackgroundColor?: string | null | undefined, primaryButtonBackgroundColor?: string | null | undefined, primaryButtonBorderColor?: string | null | undefined, primaryButtonHoverBackgroundColor?: string | null | undefined, primaryButtonHoverTextColor?: string | null | undefined, primaryButtonTextColor?: string | null | undefined, primaryColor?: string | null | undefined, primaryTextColor?: string | null | undefined, requiredIndicatorColor?: string | null | undefined, secondaryFont?: string | null | undefined, secondaryFontUrl?: string | null | undefined, secondaryFontSize?: number | null | undefined, titleFont?: string | null | undefined, titleFontUrl?: string | null | undefined, titleFontSize?: number | null | undefined } | null | undefined } } };

export type FormBrandedCustomizationsPartsFragment = { __typename?: 'FormBrandedCustomizations', borderRadius?: number | null | undefined, buttonBorderRadius?: number | null | undefined, buttonColor?: string | null | undefined, buttonFont?: string | null | undefined, buttonFontUrl?: string | null | undefined, dateTimeBackgroundColor?: string | null | undefined, dateTimeTextColor?: string | null | undefined, formBackgroundColor?: string | null | undefined, containerBorderRadius?: number | null | undefined, hasPoweredByWistiaBadge?: boolean | null | undefined, headingTextColor?: string | null | undefined, inputBorderColor?: string | null | undefined, inputBorderRadius?: number | null | undefined, inputFont?: string | null | undefined, inputFontUrl?: string | null | undefined, inputLabelFont?: string | null | undefined, inputLabelFontUrl?: string | null | undefined, inputTextColor?: string | null | undefined, mainTextColor?: string | null | undefined, pageBackgroundColor?: string | null | undefined, primaryButtonBackgroundColor?: string | null | undefined, primaryButtonBorderColor?: string | null | undefined, primaryButtonHoverBackgroundColor?: string | null | undefined, primaryButtonHoverTextColor?: string | null | undefined, primaryButtonTextColor?: string | null | undefined, primaryColor?: string | null | undefined, primaryTextColor?: string | null | undefined, requiredIndicatorColor?: string | null | undefined, secondaryFont?: string | null | undefined, secondaryFontUrl?: string | null | undefined, secondaryFontSize?: number | null | undefined, titleFont?: string | null | undefined, titleFontUrl?: string | null | undefined, titleFontSize?: number | null | undefined };

export const FormBrandedCustomizationsPartsFragmentDoc = gql`
    fragment FormBrandedCustomizationsParts on FormBrandedCustomizations {
  borderRadius
  buttonBorderRadius
  buttonColor
  buttonFont
  buttonFontUrl
  dateTimeBackgroundColor
  dateTimeTextColor
  formBackgroundColor
  containerBorderRadius
  hasPoweredByWistiaBadge
  headingTextColor
  inputBorderColor
  inputBorderRadius
  inputFont
  inputFontUrl
  inputLabelFont
  inputLabelFontUrl
  inputTextColor
  mainTextColor
  pageBackgroundColor
  primaryButtonBackgroundColor
  primaryButtonBorderColor
  primaryButtonHoverBackgroundColor
  primaryButtonHoverTextColor
  primaryButtonTextColor
  primaryColor
  primaryTextColor
  requiredIndicatorColor
  secondaryFont
  secondaryFontUrl
  secondaryFontSize
  titleFont
  titleFontUrl
  titleFontSize
}
    `;
export const GetUnregisteredFormDocument = gql`
    query GetUnregisteredForm($id: ID!) {
  form(id: $id) {
    id
    formFields {
      id
      slug
      enabled
      required
      custom
      inputType
      label
      placeholder
      options {
        label
        value
      }
      integrationSettings {
        fieldMappings {
          id
          isCustom
        }
        integrationId
      }
      validation {
        isLength {
          minLength
          maxLength
        }
      }
    }
    customizations {
      brandedValues {
        ...FormBrandedCustomizationsParts
      }
    }
  }
}
    ${FormBrandedCustomizationsPartsFragmentDoc}`;

/**
 * __useGetUnregisteredFormQuery__
 *
 * To run a query within a React component, call `useGetUnregisteredFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnregisteredFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnregisteredFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUnregisteredFormQuery(baseOptions: Apollo.QueryHookOptions<GetUnregisteredFormQuery, GetUnregisteredFormQueryVariables> & ({ variables: GetUnregisteredFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnregisteredFormQuery, GetUnregisteredFormQueryVariables>(GetUnregisteredFormDocument, options);
      }
export function useGetUnregisteredFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnregisteredFormQuery, GetUnregisteredFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnregisteredFormQuery, GetUnregisteredFormQueryVariables>(GetUnregisteredFormDocument, options);
        }
export function useGetUnregisteredFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnregisteredFormQuery, GetUnregisteredFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnregisteredFormQuery, GetUnregisteredFormQueryVariables>(GetUnregisteredFormDocument, options);
        }
export type GetUnregisteredFormQueryHookResult = ReturnType<typeof useGetUnregisteredFormQuery>;
export type GetUnregisteredFormLazyQueryHookResult = ReturnType<typeof useGetUnregisteredFormLazyQuery>;
export type GetUnregisteredFormSuspenseQueryHookResult = ReturnType<typeof useGetUnregisteredFormSuspenseQuery>;
export type GetUnregisteredFormQueryResult = Apollo.QueryResult<GetUnregisteredFormQuery, GetUnregisteredFormQueryVariables>;